// =============================================================
// Wires the contest-rules disclaimer modal. Uses a native <dialog>
// so ESC-to-close and focus handling come for free; we add the
// trigger, the close button, and backdrop-click-to-dismiss.
// =============================================================

function init() {
  const modal = document.querySelector<HTMLDialogElement>("#contest-rules-modal");
  if (!modal) {
    return;
  }

  const openers = document.querySelectorAll<HTMLElement>('[data-modal-open="contest-rules"]');
  openers.forEach((opener) => {
    opener.addEventListener("click", (event) => {
      event.preventDefault();
      modal.showModal();
    });
  });

  const closers = modal.querySelectorAll<HTMLElement>("[data-modal-close]");
  closers.forEach((closer) => {
    closer.addEventListener("click", () => {
      modal.close();
    });
  });

  // A click that lands on the dialog element itself (not the panel) is a click
  // on the backdrop — dismiss.
  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.close();
    }
  });
}

init();

export {};
